import { createFileRoute, redirect } from "@tanstack/react-router";
import { Callout } from "@/components/ui/callout";
import { FormPageSkeleton } from "@/components/app/skeletons";
import { useAuth } from "@/features/auth/store";
import { PassInFormPage } from "@/features/gate-pass-in/components/pass-in-form-page";
import { errMsg, useGatePassIn } from "@/features/gate-pass-in/hooks";

export const Route = createFileRoute("/_app/gate/pass-in/$id")({
  beforeLoad: () => {
    if (!useAuth.getState().can("gate.view")) throw redirect({ to: "/" });
  },
  component: Page,
});

function Page() {
  const { id } = Route.useParams();
  const pass = useGatePassIn(Number(id));
  if (pass.isPending) return <FormPageSkeleton />;
  if (pass.isError)
    return (
      <Callout tone="danger" title="Could not open this gate pass">
        {errMsg(pass.error)}
      </Callout>
    );
  // Keyed on the saved version, so a save or cancel re-seeds the form from what the server holds.
  return (
    <PassInFormPage
      key={`${pass.data.id}-${pass.data.status}`}
      pass={pass.data}
      facilityId={pass.data.facilityId}
      plantName={pass.data.plantName}
    />
  );
}
